import { PillVariants } from "src/base-components/Pill";
import { Option } from "src/base-components/Select";
import { CaseStatusPill } from "src/cases/common/CaseStatusPill";
import { CaseQueueColumnSchemaOption } from "src/cases/queues/types";
import {
  buildBackendStatusKey,
  buildStatusLabel,
} from "src/cases/templates/utils";

export const STATUS_FIELD_KEY = "properties.status+enum";

type StatusPair = {
  status: string;
  subStatus?: string;
  statusLabel: string;
  subStatusLabel?: string;
  variant: PillVariants | undefined;
};

const toPairOption = ({
  status,
  subStatus,
  statusLabel,
  subStatusLabel,
  variant,
}: StatusPair): Option => ({
  key: buildBackendStatusKey({ status, subStatus }),
  value: (
    <CaseStatusPill
      status={statusLabel}
      subStatus={subStatusLabel}
      variant={variant}
    />
  ),
  displayValue: buildStatusLabel({
    status: statusLabel,
    subStatus: subStatusLabel,
  }),
  pillVariant: variant,
});

/**
 * The status column schema already holds one option per status/sub-status pair,
 * deduplicated across the queue's template versions.
 */
export const buildStatusPairOptions = (
  options: CaseQueueColumnSchemaOption[],
): Option[] =>
  options.map((option) =>
    toPairOption({
      status: option.value,
      subStatus: option.subValue?.value,
      statusLabel: option.displayName,
      subStatusLabel: option.subValue?.displayName,
      variant: option.color as PillVariants | undefined,
    }),
  );
